module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan de base.3c9e2e48.svg";